// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"c0b0e04d","474":"31d6cfe0","699":"eea1b490"}[chunkId] + ".chunk.css";
};